import { Box, Typography, CssBaseline, ThemeProvider, useTheme } from "@mui/material";
import { useAppDispatch } from "../../common/state/hooks";
import { useEffect } from "react";
import { update } from "../../common/state/Slices/HeaderMenuSlice";
import { Routes } from "../../routes/routes";
import styles from "./HelpSupport.module.css";

declare const genv: any;
const mailLink = `mailto:${genv.GARUDA_HELPLINE_EMAIL}`;

export const HelpSupport = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      update({
        selectedMenu: Routes.HELP_SUPPORT
      })
    );
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box className={styles.container}>
        <Box className={styles.card}>
          <Typography variant="h4" color="primary" className={styles.mainText}>
            Help and Support
          </Typography>
          <Typography variant="body2" className={styles.secondaryText}>
            We’re here to help you make the most of Garuda2x. Whether you’re
            exploring the trial version, troubleshooting an issue, or interested
            in custom solutions, our team is ready to assist you at every step.
          </Typography>

          <Box className={styles.infoSection}>
            <Typography variant="body2" className={styles.infoText}>
              For all inquiries, technical support, installation assistance, custom
              workflows, or to learn more about the full version of Garuda2x, please
              contact us at:{" "}
              <span>
                <a href={mailLink} className={styles.emailLink}>
                  📧 info@sbx-corp.com
                </a>
              </span>
            </Typography>
          </Box>

          <Box className={styles.infoSection}>
            <Typography variant="body2" className={styles.infoText}>
              We aim to provide timely and comprehensive support to ensure your
              experience with Garuda2x is smooth and productive. Don’t hesitate
              to reach out, we’re always happy to help!
            </Typography>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};